import { render, staticRenderFns } from "./ModalDeliveryTime.vue?vue&type=template&id=9dce89b4&lang=pug&"
import script from "./ModalDeliveryTime.vue?vue&type=script&lang=js&"
export * from "./ModalDeliveryTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports